/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Rails from 'rails-ujs';
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';

import flatpickr from 'flatpickr';

import SiteHeaderSearch from '../components/site_header_search/site_header_search.vue';

import '../native/forms';

import '../styles/application.scss';

import $ from 'jquery';

Vue.use(VueApollo);

Rails.start();

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
} else {
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };
}

$(function() {
  $('a.read-more-less').on('click', function(e) {
    e.preventDefault();
    const link = $(this);
    const paragraph = link.prev('p');

    if (link.text() === 'Read more') {
      paragraph.removeAttr('style');
      link.text('Read less');
    } else {
      paragraph.attr('style', '-webkit-box-orient: vertical;');
      link.text('Read more');
    }
  });

  $('#view-toggle').on('click', function(e) {
    e.preventDefault();
    const link = $(this);

    if (link.text() === 'View more') {
      $('.segment').show();
      link.text('View less');
    } else {
      $('.segment:nth-child(n+4)').hide();
      link.text('View more');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const csrfToken = document.head.querySelector('[name=csrf-token]').content;

  const apolloProvider = new VueApollo({
    defaultClient: new ApolloClient({
      uri: '/graphql',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-TOKEN': csrfToken,
      },
    }),
  });

  const componentData = document.querySelector('site-header-search').dataset;

  (() => new Vue({
    el: 'site-header-search',
    apolloProvider,
    render: h => h(SiteHeaderSearch, {
      props: {
        country: componentData.country,
      },
    }),
  }))();

  const siteHeader = document.getElementsByClassName('js__site-header')[0];

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      siteHeader.classList.add('site-header--scrolled');
    } else if (window.scrollY < 2) {
      siteHeader.classList.remove('site-header--scrolled');
    }
  });

  // Listener to open site header search
  const searchContainer = document.querySelector('.js__site-header__search-container');

  document.querySelector('.js__site-header-search-button').addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('.js__site-footer-search-button').click();
    document.querySelector('.js__backdrop').classList.remove('d-none');
  });

  // Listener to close site header search
  document.querySelector('.js__site-header__search-close').addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('.js__site-footer-search-button').click();
    document.querySelector('.js__backdrop').classList.add('d-none');
  });

  document.querySelector('.js__backdrop').addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('.js__site-header__search-close').click();
  });

  document.querySelector('.js__site-footer-search-button').addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('.js__backdrop').classList.toggle('d-none');
  });

  document.addEventListener('keydown', (event) => {
    const searchContainerActive = document.querySelector(".js__site-header__search-container.active")
    if (searchContainerActive) {
      if (event.key === "Escape") {
        document.querySelector('.js__site-header__search-close').click();
      }
    }
  })

  document.querySelector('.js__site-header-menu-button').addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('.js__site-header-menu-button').classList.toggle('active');

    const siteSubHeader = document.querySelector('.js__site-header-sub');
    siteSubHeader.classList.add('active');

    if (siteSubHeader.classList.contains('slideInDown')) {
      siteSubHeader.classList.replace('slideInDown', 'slideOutUp');
    } else {
      siteSubHeader.classList.replace('slideOutUp', 'slideInDown');
    }
  });

  document.querySelector('.js__site-footer-search-button').addEventListener('click', (event) => {
    event.preventDefault();

    if (document.querySelector('.js__site-footer-search-button').classList.contains('disabled')) {
      return false;
    }

    searchContainer.classList.toggle('active');

    const menuButton = document.querySelector('.js__site-footer-search-button svg');
    if (menuButton.classList.contains('fa-search')) {
      menuButton.classList.replace('fa-search', 'fa-times');
    } else {
      menuButton.classList.replace('fa-times', 'fa-search');
    }

    if (searchContainer.classList.contains('active')) {
      document.querySelector('.js__site-header__search-container input').focus();
    }

    document.querySelector('.js__site-footer-country-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-menu-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-locale-button').classList.toggle('disabled');
  });

  document.querySelector('.js__site-footer-menu-button').addEventListener('click', (event) => {
    event.preventDefault();

    if (document.querySelector('.js__site-footer-menu-button').classList.contains('disabled')) {
      return false;
    }

    document.querySelector('.js__site-footer-menu-button').classList.toggle('active');

    const menuButton = document.querySelector('.js__site-footer-menu-button svg');
    if (menuButton.classList.contains('fa-bars')) {
      menuButton.classList.replace('fa-bars', 'fa-times');
    } else {
      menuButton.classList.replace('fa-times', 'fa-bars');
    }

    const siteSubFooter = document.querySelector('.js__footer-nav-sub');
    siteSubFooter.classList.add('active');

    if (siteSubFooter.classList.contains('slideInUp')) {
      siteSubFooter.classList.replace('slideInUp', 'slideOutDown');
    } else {
      siteSubFooter.classList.replace('slideOutDown', 'slideInUp');
    }

    document.querySelector('.js__site-footer-country-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-locale-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-search-button').classList.toggle('disabled');
  });

  document.querySelector('.js__site-footer-country-button').addEventListener('click', (event) => {
    event.preventDefault();

    if (document.querySelector('.js__site-footer-country-button').classList.contains('disabled')) {
      return false;
    }

    document.querySelector('.js__site-footer-country-button').classList.toggle('active');

    const siteSubFooter = document.querySelector('.js__footer-country-sub');

    if (document.querySelector('.js__site-footer-country-button').classList.contains('active')) {
      siteSubFooter.classList.add('active');
      siteSubFooter.classList.replace('fadeOut', 'fadeIn');
    } else {
      siteSubFooter.classList.replace('fadeIn', 'fadeOut');
    }
    document.querySelector('.js__site-footer-locale-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-menu-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-search-button').classList.toggle('disabled');
  });

  document.querySelector('.js__site-footer-locale-button').addEventListener('click', (event) => {
    event.preventDefault();

    if (document.querySelector('.js__site-footer-locale-button').classList.contains('disabled')) {
      return false;
    }

    document.querySelector('.js__site-footer-locale-button').classList.toggle('active');

    const siteSubFooter = document.querySelector('.js__footer-locale-sub');

    if (document.querySelector('.js__site-footer-locale-button').classList.contains('active')) {
      siteSubFooter.classList.add('active');
      siteSubFooter.classList.replace('fadeOut', 'fadeIn');
    } else {
      siteSubFooter.classList.replace('fadeIn', 'fadeOut');
    }


    document.querySelector('.js__site-footer-country-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-menu-button').classList.toggle('disabled');
    document.querySelector('.js__site-footer-search-button').classList.toggle('disabled');
  });

  const localeSub = document.querySelector('.js__footer-locale-sub');

  localeSub.addEventListener('animationend', () => {
    if (!document.querySelector('.js__site-footer-locale-button').classList.contains('active')) {
      localeSub.classList.remove('active');
    }
  });

  const countrySub = document.querySelector('.js__footer-country-sub');

  countrySub.addEventListener('animationend', () => {
    if (!document.querySelector('.js__site-footer-country-button').classList.contains('active')) {
      countrySub.classList.remove('active');
    }
  });

  const elementArrays = document.querySelectorAll(".footer-nav-sub__icon");

  elementArrays.forEach(function(element) {
    element.addEventListener("click", function(event) {
      event.preventDefault();
      this.classList.toggle("rotate-180");
      this.classList.toggle("active");
      const content = this.closest("div.footer-nav-sub__title").nextElementSibling;

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    })
  })

  // Modal activation
  const modalActivationButtons = document.querySelectorAll('.js__activate-modal-button');

  for (let i = 0; i < modalActivationButtons.length; i += 1) {
    const modalActivationButton = modalActivationButtons[i];

    modalActivationButton.addEventListener('click', (event) => {
      event.preventDefault();
      const targetModal = document.querySelector(modalActivationButton.dataset.target);
      targetModal.classList.add('active');
    });
  }

  // Modal close
  const modalCloseButtons = document.querySelectorAll('.js__modal-close-button');

  for (let i = 0; i < modalCloseButtons.length; i += 1) {
    const modalCloseButton = modalCloseButtons[i];

    modalCloseButton.addEventListener('click', (event) => {
      event.preventDefault();
      modalCloseButton.closest('.js__modal-container').classList.remove('active');
    });
  }

  const modalContainers = document.querySelectorAll('.js__modal-container');

  for (let i = 0; i < modalContainers.length; i += 1) {
    const modalContainer = modalContainers[i];

    modalContainer.addEventListener('click', (event) => {
      if (event.target !== modalContainer) return;
      modalContainer.classList.remove('active');
    });
  }

  // Initialise flatpickr.js date inputs
  const flatpickrDateElements = document.querySelectorAll('.js__datepicker');

  for (let i = 0; i < flatpickrDateElements.length; i += 1) {
    const flatpickrDateElement = flatpickrDateElements[i];

    flatpickr(flatpickrDateElement, {
      altInput: true,
      altFormat: 'j F Y',
      defaultDate: flatpickrDateElement.dataset.defaultDate,
    });
  }

  // Initialise flatpickr.js time inputs
  const flatpickrTimeElements = document.querySelectorAll('.js__timepicker');

  for (let i = 0; i < flatpickrTimeElements.length; i += 1) {
    const flatpickrTimeElement = flatpickrTimeElements[i];

    flatpickr(flatpickrTimeElement, {
      enableTime: true,
      noCalendar: true,
      defaultDate: flatpickrTimeElement.dataset.defaultDate,
    });
  }

  const  iframe = document.querySelector('.vimeo-player');
  const controller = document.querySelector('.audio-control');
  const player = iframe ? new Vimeo.Player(iframe) : null;

  function muteAudio() {
    let audioStatus = controller.classList.contains('unmuted') ? true : false;

    if (audioStatus === false) {
      // Mute the audio
      player.setVolume(0).then(function() {
        controller.classList.remove('muted');
        controller.classList.add('unmuted');
      })
    }
    else if (audioStatus === true){
      // Play the audio
      player.setVolume(1).then(function() {
        controller.classList.remove('unmuted');
        controller.classList.add('muted');
      })
    }
  }

  if (controller) {
    controller.addEventListener("click", function(e) {
      muteAudio();
      e.preventDefault();
    })
  }

  (function(d, s, id){var js; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = "https://embedsocial.com/embedscript/stg.js"; d.getElementsByTagName("head")[0].appendChild(js);}(document, "script", "EmbedSocialStoryGalleryScript"));
});
